export const AUTH_ERROR_CODES = {
	'auth/claims-too-large':
		'The claims payload provided to setCustomUserClaims() exceeds the maximum allowed size of 1000 bytes.',
	'auth/email-already-exists':
		'The provided email is already in use by an existing user. Each user must have a unique email.',
	'auth/id-token-expired': 'The provided Firebase ID token is expired.',
	'auth/id-token-revoked': 'The Firebase ID token has been revoked.',
	'auth/insufficient-permission':
		'The credential used to initialize the Admin SDK has insufficient permission to access the requested Authentication resource. Refer to Set up a Firebase project for documentation on how to generate a credential with appropriate permissions and use it to authenticate the Admin SDKs.',
	'auth/internal-error':
		'The Authentication server encountered an unexpected error while trying to process the request. The error message should contain the response from the Authentication server containing additional information. If the error persists, please report the problem to our Bug Report support channel.',
	'auth/invalid-argument':
		'An invalid argument was provided to an Authentication method. The error message should contain additional information.',
	'auth/invalid-claims':
		'The custom claim attributes provided to setCustomUserClaims() are invalid.',
	'auth/invalid-continue-uri': 'The continue URL must be a valid URL string.',
	'auth/invalid-creation-time': 'The creation time must be a valid UTC date string.',
	'auth/invalid-credential':
		'The credential used to authenticate the Admin SDKs cannot be used to perform the desired action. Certain Authentication methods such as createCustomToken() and verifyIdToken() require the SDK to be initialized with a certificate credential as opposed to a refresh token or Application Default credential. See Initialize the SDK for documentation on how to authenticate the Admin SDKs with a certificate credential.',
	'auth/invalid-disabled-field':
		'The provided value for the disabled user property is invalid. It must be a boolean.',
	'auth/invalid-display-name':
		'The provided value for the displayName user property is invalid. It must be a non-empty string.',
	'auth/invalid-dynamic-link-domain':
		'The provided dynamic link domain is not configured or authorized for the current project.',
	'auth/invalid-email':
		'The provided value for the email user property is invalid. It must be a string email address.',
	'auth/invalid-email-verified':
		'The provided value for the emailVerified user property is invalid. It must be a boolean.',
	'auth/invalid-hash-algorithm':
		'The hash algorithm must match one of the strings in the list of supported algorithms.',
	'auth/invalid-hash-block-size': 'The hash block size must be a valid number.',
	'auth/invalid-hash-derived-key-length': 'The hash derived key length must be a valid number.',
	'auth/invalid-hash-key': 'The hash key must a valid byte buffer.',
	'auth/invalid-hash-memory-cost': 'The hash memory cost must be a valid number.',
	'auth/invalid-hash-parallelization': 'The hash parallelization must be a valid number.',
	'auth/invalid-hash-rounds': 'The hash rounds must be a valid number.',
	'auth/invalid-hash-salt-separator':
		'The hashing algorithm salt separator field must be a valid byte buffer.',
	'auth/invalid-id-token': 'The provided ID token is not a valid Firebase ID token.',
	'auth/invalid-last-sign-in-time': 'The last sign-in time must be a valid UTC date string.',
	'auth/invalid-page-token':
		'The provided next page token in listUsers() is invalid. It must be a valid non-empty string.',
	'auth/invalid-password':
		'The provided value for the password user property is invalid. It must be a string with at least six characters.',
	'auth/invalid-password-hash': 'The password hash must be a valid byte buffer.',
	'auth/invalid-password-salt': 'The password salt must be a valid byte buffer',
	'auth/invalid-phone-number':
		'The provided value for the phoneNumber is invalid. It must be a non-empty E.164 standard compliant identifier string.',
	'auth/invalid-photo-url':
		'The provided value for the photoURL user property is invalid. It must be a string URL.',
	'auth/invalid-provider-data': 'The providerData must be a valid array of UserInfo objects.',
	'auth/invalid-provider-id':
		'The providerId must be a valid supported provider identifier string.',
	'auth/invalid-oauth-responsetype': 'Only exactly one OAuth responseType should be set to true.',
	'auth/invalid-session-cookie-duration':
		'The session cookie duration must be a valid number in milliseconds between 5 minutes and 2 weeks.',
	'auth/invalid-uid': 'The provided uid must be a non-empty string with at most 128 characters.',
	'auth/invalid-user-import': 'The user record to import is invalid.',
	'auth/maximum-user-count-exceeded':
		'The maximum allowed number of users to import has been exceeded.',
	'auth/missing-android-pkg-name':
		'An Android Package Name must be provided if the Android App is required to be installed.',
	'auth/missing-continue-uri': 'A valid continue URL must be provided in the request.',
	'auth/missing-hash-algorithm':
		'Importing users with password hashes requires that the hashing algorithm and its parameters be provided.',
	'auth/missing-ios-bundle-id': 'The request is missing an iOS Bundle ID.',
	'auth/missing-uid': 'A uid identifier is required for the current operation.',
	'auth/missing-oauth-client-secret':
		'The OAuth configuration client secret is required to enable OIDC code flow.',
	'auth/operation-not-allowed':
		'The provided sign-in provider is disabled for your Firebase project. Enable it from the Sign-in Method section of the Firebase console.',
	'auth/phone-number-already-exists':
		'The provided phoneNumber is already in use by an existing user. Each user must have a unique phoneNumber.',
	'auth/project-not-found':
		'No Firebase project was found for the credential used to initialize the Admin SDKs. Refer to Set up a Firebase project for documentation on how to generate a credential for your project and use it to authenticate the Admin SDKs.',
	'auth/reserved-claims':
		'One or more custom user claims provided to setCustomUserClaims() are reserved. For example, OIDC specific claims such as (sub, iat, iss, exp, aud, auth_time, etc) should not be used as keys for custom claims.',
	'auth/session-cookie-expired': 'The provided Firebase session cookie is expired.',
	'auth/session-cookie-revoked': 'The Firebase session cookie has been revoked.',
	'auth/uid-already-exists':
		'The provided uid is already in use by an existing user. Each user must have a unique uid.',
	'auth/unauthorized-continue-uri':
		'The domain of the continue URL is not whitelisted. Whitelist the domain in the Firebase Console.',
	'auth/user-not-found':
		'There is no existing user record corresponding to the provided identifier.',
	'auth/wrong-password': 'The password is incorrect!'
}

export const DEFAULT_DRAG_ACTIONS = ['moved', 'added', 'removed']

export const DEFAULT_PRODUCT_CARD = {
	category: 'Finance',
	name: 'Fundamentals of Investment Banking',
	short_description:
		'Explores the introductory areas of investment banking in the modern day and age',
	lesson_count: 10,
	instructor: {
		name: 'Chan Doe',
		position: 'Venture Capitalist',
		avatar: 'https://tuk-cdn.s3.amazonaws.com/assets/components/avatars/a_4_4.png'
	}
}

export const DEFAULT_CATEGORIES = [
	{
		name: 'Category 1',
		value: 'Category 1',
		children: [
			{ name: 'Sub-Category 1', value: 'Category-1/Sub-Category 1' },
			{ name: 'Sub-Category 2', value: 'Category-1/Sub-Category 2' },
			{ name: 'Sub-Category 3', value: 'Category-1/Sub-Category 3' }
		]
	},
	{
		name: 'Category 2',
		value: 'Category 2',
		children: [
			{ name: 'Sub-Category 1', value: 'Category-2/Sub-Category 1' },
			{ name: 'Sub-Category 2', value: 'Category-2/Sub-Category 2' }
		]
	},
	{
		name: 'Category 3',
		value: 'Category 3',
		children: [
			{ name: 'Sub-Category 1', value: 'Category-3/Sub-Category 1' },
			{ name: 'Sub-Category 2', value: 'Category-3/Sub-Category 2' },
			{ name: 'Sub-Category 3', value: 'Category-3/Sub-Category 3' },
			{ name: 'Sub-Category 4', value: 'Category-3/Sub-Category 4' }
		]
	},
	{
		name: 'Category 4',
		value: 'Category 4',
		children: [{ name: 'Sub-Category 1', value: 'Category-4/Sub-Category 1' }]
	}
]

export const dayOfWeek = [
	{ name: 'Monday', value: 'Monday' },
	{ name: 'Tuesday', value: 'Tuesday' },
	{ name: 'Wednesday', value: 'Wednesday' },
	{ name: 'Thursday', value: 'Thursday' },
	{ name: 'Friday', value: 'Friday' },
	{ name: 'Saturday', value: 'Saturday' },
	{ name: 'Sunday', value: 'Sunday' },
	{ name: 'Mon-Fri', value: 'Mon - Fri' }
]

export const timeOfDay = [
	{
		name: '12:00 AM',
		value: '12:00 AM'
	},
	{
		name: '12:30 AM',
		value: '12:30 AM'
	},
	{
		name: '1:00 AM',
		value: '1:00 AM'
	},
	{
		name: '1:30 AM',
		value: '1:30 AM'
	},
	{
		name: '2:00 AM',
		value: '2:00 AM'
	},
	{
		name: '2:30 AM',
		value: '2:30 AM'
	},
	{
		name: '3:00 AM',
		value: '3:00 AM'
	},
	{
		name: '3:30 AM',
		value: '3:30 AM'
	},
	{
		name: '4:00 AM',
		value: '4:00 AM'
	},
	{
		name: '4:30 AM',
		value: '4:30 AM'
	},
	{
		name: '5:00 AM',
		value: '5:00 AM'
	},
	{
		name: '5:30 AM',
		value: '5:30 AM'
	},
	{
		name: '6:00 AM',
		value: '6:00 AM'
	},
	{
		name: '6:30 AM',
		value: '6:30 AM'
	},
	{
		name: '7:00 AM',
		value: '7:00 AM'
	},
	{
		name: '7:30 AM',
		value: '7:30 AM'
	},
	{
		name: '8:00 AM',
		value: '8:00 AM'
	},
	{
		name: '8:30 AM',
		value: '8:30 AM'
	},
	{
		name: '9:00 AM',
		value: '9:00 AM'
	},
	{
		name: '9:30 AM',
		value: '9:30 AM'
	},
	{
		name: '10:00 AM',
		value: '10:00 AM'
	},
	{
		name: '10:30 AM',
		value: '10:30 AM'
	},
	{
		name: '11:00 AM',
		value: '11:00 AM'
	},
	{
		name: '11:30 AM',
		value: '11:30 AM'
	},
	{
		name: '12:00 PM',
		value: '12:00 PM'
	},
	{
		name: '12:30 PM',
		value: '12:30 PM'
	},
	{
		name: '1:00 PM',
		value: '1:00 PM'
	},
	{
		name: '1:30 PM',
		value: '1:30 PM'
	},
	{
		name: '2:00 PM',
		value: '2:00 PM'
	},
	{
		name: '2:30 PM',
		value: '2:30 PM'
	},
	{
		name: '3:00 PM',
		value: '3:00 PM'
	},
	{
		name: '3:30 PM',
		value: '3:30 PM'
	},
	{
		name: '4:00 PM',
		value: '4:00 PM'
	},
	{
		name: '4:30 PM',
		value: '4:30 PM'
	},
	{
		name: '5:00 PM',
		value: '5:00 PM'
	},
	{
		name: '5:30 PM',
		value: '5:30 PM'
	},
	{
		name: '6:00 PM',
		value: '6:00 PM'
	},
	{
		name: '6:30 PM',
		value: '6:30 PM'
	},
	{
		name: '7:00 PM',
		value: '7:00 PM'
	},
	{
		name: '7:30 PM',
		value: '7:30 PM'
	},
	{
		name: '8:00 PM',
		value: '8:00 PM'
	},
	{
		name: '8:30 PM',
		value: '8:30 PM'
	},
	{
		name: '9:00 PM',
		value: '9:00 PM'
	},
	{
		name: '9:30 PM',
		value: '9:30 PM'
	},
	{
		name: '10:00 PM',
		value: '10:00 PM'
	},
	{
		name: '10:30 PM',
		value: '10:30 PM'
	},
	{
		name: '11:00 PM',
		value: '11:00 PM'
	},
	{
		name: '11:30 PM',
		value: '11:30 PM'
	}
]

export const timeOfDayB = [
	{
		name: '08:00',
		value: '08:00'
	},
	{
		name: '08:30',
		value: '08:30'
	},
	{
		name: '09:00',
		value: '09:00'
	},
	{
		name: '09:30',
		value: '09:30'
	},
	{
		name: '10:00',
		value: '10:00'
	},
	{
		name: '10:30',
		value: '10:30'
	},
	{
		name: '11:00',
		value: '11:00'
	},
	{
		name: '11:30',
		value: '11:30'
	},

	{
		name: '12:00',
		value: '12:00'
	},
	{
		name: '12:30',
		value: '12:30'
	},
	{
		name: '13:00',
		value: '13:00'
	},
	{
		name: '13:30',
		value: '13:30'
	},
	{
		name: '14:00',
		value: '14:00'
	},
	{
		name: '14:30',
		value: '14:30'
	},
	{
		name: '15:00',
		value: '15:00'
	},
	{
		name: '15:30',
		value: '15:30'
	},
	{
		name: '16:00',
		value: '16:00'
	},
	{
		name: '16:30',
		value: '16:30'
	},
	{
		name: '17:00',
		value: '17:00'
	},
	{
		name: '17:30',
		value: '17:30'
	},
	{
		name: '18:00',
		value: '18:00'
	},
	{
		name: '18:30',
		value: '18:30'
	},
	{
		name: '19:00',
		value: '19:00'
	},
	{
		name: '19:30',
		value: '19:30'
	},
	{
		name: '20:00',
		value: '20:00'
	}
]

export const regions = [
	{
		name: 'Argentina',
		value: 'AR'
	},
	{
		name: 'Aruba',
		value: 'AW'
	},
	{
		name: 'Australia',
		value: 'AU'
	},
	{
		name: 'Austria',
		value: 'AT'
	},
	{
		name: 'Bahamas',
		value: 'BS'
	},
	{
		name: 'Barbados',
		value: 'BB'
	},
	{
		name: 'Belgium',
		value: 'BE'
	},
	{
		name: 'Brazil',
		value: 'BR'
	},
	{
		name: 'Canada',
		value: 'CA'
	},
	{
		name: 'China',
		value: 'CN'
	},
	{
		name: 'Costa Rica',
		value: 'CR'
	},
	{
		name: 'Cuba',
		value: 'CU'
	},
	{
		name: 'Cyprus',
		value: 'CY'
	},
	{
		name: 'Denmark',
		value: 'DK'
	},
	{
		name: 'Fiji',
		value: 'FJ'
	},
	{
		name: 'Finland',
		value: 'FI'
	},
	{
		name: 'France',
		value: 'FR'
	},
	{
		name: 'Germany',
		value: 'DE'
	},
	{
		name: 'Gibraltar',
		value: 'GI'
	},
	{
		name: 'Guernsey',
		value: 'GG'
	},
	{
		name: 'Hong Kong',
		value: 'HK'
	},
	{
		name: 'India',
		value: 'IN'
	},
	{
		name: 'Indonesia',
		value: 'ID'
	},
	{
		name: 'Ireland',
		value: 'IE'
	},
	{
		name: 'Isle of Man',
		value: 'IM'
	},
	{
		name: 'Italy',
		value: 'IT'
	},
	{
		name: 'Jamaica',
		value: 'JM'
	},
	{
		name: 'Japan',
		value: 'JP'
	},
	{
		name: 'Lithuania',
		value: 'LT'
	},
	{
		name: 'Luxembourg',
		value: 'LU'
	},
	{
		name: 'Malaysia',
		value: 'MY'
	},
	{
		name: 'Malta',
		value: 'MT'
	},
	{
		name: 'Mexico',
		value: 'MX'
	},
	{
		name: 'Morocco',
		value: 'MA'
	},
	{
		name: 'Netherlands',
		value: 'NL'
	},
	{
		name: 'New Zealand',
		value: 'NZ'
	},
	{
		name: 'Norway',
		value: 'NO'
	},
	{
		name: 'Panama',
		value: 'PA'
	},
	{
		name: 'Paraguay',
		value: 'PY'
	},
	{
		name: 'Peru',
		value: 'PE'
	},
	{
		name: 'Philippines',
		value: 'PH'
	},
	{
		name: 'Poland',
		value: 'PL'
	},
	{
		name: 'Portugal',
		value: 'PT'
	},
	{
		name: 'Seychelles',
		value: 'SC'
	},
	{
		name: 'Singapore',
		value: 'SG'
	},
	{
		name: 'South Africa',
		value: 'ZA'
	},
	{
		name: 'Spain',
		value: 'ES'
	},
	{
		name: 'Sweden',
		value: 'SE'
	},
	{
		name: 'Switzerland',
		value: 'CH'
	},
	{
		name: 'Taiwan',
		value: 'TW'
	},
	{
		name: 'Thailand',
		value: 'TH'
	},
	{
		name: 'Turkey',
		value: 'TR'
	},
	{
		name: 'United Arab Emirates',
		value: 'AE'
	},
	{
		name: 'United Kingdom',
		value: 'GB'
	},
	{
		name: 'United States of America',
		value: 'US'
	}
]

// Articles constants
export const DEFAULT_ARTICLES_URL = '/articles'
export const DEFAULT_ARTICLES_LABEL = 'Articles'

export const DEFAULT_ARTICLE_POST = {
	name: '',
	path: '',
	description: '',
	status: 'draft',
	createdAt: null, // Will be set to serverTimestamp() when creating
	updatedAt: null, // Will be set to serverTimestamp() when creating/updating
	author: '',
	tags: [],
	metaTitle: '',
	metaDescription: '',
	structure: [],
	type: null // Will be set to selected article type UUID
}

export const ARTICLE_STATUS_OPTIONS = [
	{ label: 'Published', value: 'published' },
	{ label: 'Unpublished', value: 'unpublished' },
	{ label: 'Draft', value: 'draft' },
	{ label: 'Archived', value: 'archived' }
]

export const DEFAULT_ARTICLE_TYPES = [
	{
		id: 'f8e7d6c5-b4a3-4210-9876-543210fedcba',
		name: 'Articles',
		path: '/articles',
		singularLabel: 'Article',
		pluralLabel: 'Articles',
		description: 'General articles and content',
		view: 'cards',
		cardColumns: 3,
		sidebarPageId: null
	}
]

export const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'ico', 'jfif']

export const documentExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv']

export const videoExtensions = ['mp4', 'avi', 'mov', 'flv', 'wmv', 'mpg', 'mpeg', '3gp', 'mkv']

export const cloudflareImageExtensions = ['jpg', 'jpeg', 'png', 'jfif']

export const mimeToExtension = {
	// Microsoft Office formats
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	'application/vnd.ms-excel': 'xls',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
	'application/msword': 'doc',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
	'application/vnd.ms-powerpoint': 'ppt',

	// PDF
	'application/pdf': 'pdf',

	// Images
	'image/jpeg': 'jpg',
	'image/jpg': 'jpg',
	'image/png': 'png',
	'image/gif': 'gif',
	'image/webp': 'webp',
	'image/svg+xml': 'svg',
	'image/tiff': 'tiff',
	'image/bmp': 'bmp',

	// Text formats
	'text/plain': 'txt',
	'text/csv': 'csv',
	'text/html': 'html',
	'text/css': 'css',
	'text/javascript': 'js',

	// Audio
	'audio/mpeg': 'mp3',
	'audio/wav': 'wav',
	'audio/ogg': 'ogg',
	'audio/midi': 'midi',
	'audio/aac': 'aac',

	// Video
	'video/mp4': 'mp4',
	'video/mpeg': 'mpeg',
	'video/quicktime': 'mov',
	'video/webm': 'webm',
	'video/x-msvideo': 'avi',

	// Archives
	'application/zip': 'zip',
	'application/x-zip-compressed': 'zip',
	'application/x-rar-compressed': 'rar',
	'application/x-7z-compressed': '7z',
	'application/gzip': 'gz',

	// Other common formats
	'application/json': 'json',
	'application/xml': 'xml',
	'application/sql': 'sql',
	'application/graphql': 'graphql',
	'application/x-yaml': 'yaml',
	'application/vnd.android.package-archive': 'apk',
	'application/x-msdownload': 'exe',
	'application/x-sh': 'sh',
	'application/x-csh': 'csh'
}

export const sideNavTabs = [
	{
		name: 'Settings',
		subTabsText: 'Komunily Settings',
		subTabs: [
			{
				name: 'Default Settings',
				tabIdentifier: 'TenantDetails',
				icon: 'PhBuildings'
			},
			{
				name: 'Regions',
				tabIdentifier: 'regions',
				icon: 'PhGlobeHemisphereWest'
			},
			{
				name: 'Domains',
				tabIdentifier: 'Domains',
				icon: 'PhGlobe'
			},
			{
				name: 'Branding',
				tabIdentifier: 'Branding',
				icon: 'PhPaintBrush'
			},
			{
				name: 'Features',
				tabIdentifier: 'features',
				icon: 'PhToggleLeft'
			},
			{
				name: 'Categories',
				tabIdentifier: 'categories',
				icon: 'PhSquaresFour'
			},
			{
				name: 'Community',
				tabIdentifier: 'community-settings',
				icon: 'PhUsersThree'
			},
			{
				name: 'Tags',
				tabIdentifier: 'tags',
				icon: 'PhTag'
			},
			{
				name: 'Meta',
				tabIdentifier: 'Meta',
				icon: 'PhCode'
			},
			{
				name: 'Headers & Footers',
				tabIdentifier: 'Headers',
				icon: 'PhBrowser'
			},
			{
				name: 'Email Templates',
				tabIdentifier: 'emails',
				icon: 'PhEnvelope'
			},
			{
				name: 'Feedback',
				tabIdentifier: 'feedback',
				icon: 'PhQuestion'
			},
			{
				name: 'Search',
				tabIdentifier: 'Search',
				icon: 'PhMagnifyingGlass'
			},
			{
				name: 'API',
				tabIdentifier: 'API',
				icon: 'PhTerminal'
			},
			{
				name: 'Integrations',
				tabIdentifier: 'Integrations',
				icon: 'PhPlugs'
			}
		]
	},
	{
		name: 'Profile',
		subTabsText: 'Profile Management',
		subTabs: [
			{
				name: 'Edit Profile',
				tabIdentifier: 'profile',
				icon: 'PhUserCircle'
			},
			{
				name: 'Tasks',
				tabIdentifier: 'tasks',
				icon: 'PhCheckSquare'
			},
			{
				name: 'Company Details',
				tabIdentifier: 'company',
				icon: 'PhBuildings'
			},
			{
				name: 'Company Users & Licenses',
				tabIdentifier: 'company-users',
				icon: 'PhUsers'
			}
		]
	},
	{
		name: 'Forms',
		tabs: [
			{
				name: 'Dashboard',
				href: '/admin/forms',
				icon: `<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>`
			}
		],
		subTabsText: 'Forms Management',
		subTabs: []
	},
	{
		name: 'Events',
		tabs: [
			{
				name: 'Events',
				href: '/admin/events/list',
				icon: 'PhListDashes'
			},
			{
				name: 'Settings',
				href: '/admin/events/settings',
				icon: 'PhGear'
			}
		],
		subTabsText: 'Events Management',
		subTabs: []
	},
	{
		name: 'Edit Event',
		tabs: [
			{
				name: 'Events',
				href: '/admin/events/list',
				icon: 'PhListDashes'
			},
			{
				name: 'Settings',
				href: '/admin/events/settings',
				icon: 'PhGear'
			}
		],
		subTabsText: 'Event Management',
		subTabs: [
			{
				name: 'Event Dashboard',
				displayName: 'Dashboard',
				tabIdentifier: 'event-dashboard',
				icon: 'PhChartBar'
			},
			{
				name: 'Event Schedule',
				displayName: 'Schedule',
				tabIdentifier: 'event-schedule',
				icon: 'PhCalendar'
			},
			{
				name: 'Event Sessions',
				displayName: 'Sessions',
				tabIdentifier: 'event-sessions',
				icon: 'PhGraduationCap'
			},
			{
				name: 'Event Partners',
				displayName: 'Partners',
				tabIdentifier: 'event-partners',
				icon: 'PhHandshake'
			},
			{
				name: 'Event Speakers',
				displayName: 'Speakers',
				tabIdentifier: 'event-speakers',
				icon: 'PhMicrophone'
			},
			{
				name: 'Event Attendees',
				displayName: 'Attendees',
				tabIdentifier: 'event-attendees',
				icon: 'PhUsers'
			},
			{
				name: 'Event Embed',
				displayName: 'Embed',
				tabIdentifier: 'event-embed',
				icon: 'PhCode'
			},
			{
				name: 'Event Emails',
				displayName: 'Emails',
				tabIdentifier: 'event-emails',
				icon: 'PhEnvelope'
			},
			{
				name: 'Event Settings',
				displayName: 'Settings',
				tabIdentifier: 'event-settings',
				icon: 'PhSliders'
			}
		]
	}
]
